import { useCartSummary } from '@/app/cartContext';
import {ShoppingCartOutlined} from '@ant-design/icons';

import styles from './mobile-cart-float-button.module.css';

export const MobileCartFloatButton = ({
  setIsCartOpen,
}: {
  setIsCartOpen: (isOpen: boolean) => void;
}) => {
  const { count, total } = useCartSummary();

  return (
    <div className={styles.floatingContainer} onClick={() => setIsCartOpen(true)}>
      
      <div className={styles.cartButton}>
        <div className={styles.itemCount}>{count}</div>
        <ShoppingCartOutlined className={styles.cartIcon} />
      </div>
      <div className={styles.priceBadge}>{total} ₽</div>
    </div>
  );
};